import { render } from "./PunishmentEntriesList.vue?vue&type=template&id=37598b80&scoped=true"
const script = {}

import "./PunishmentEntriesList.vue?vue&type=style&index=0&id=37598b80&scoped=true&lang=css"
import "./PunishmentEntriesList.vue?vue&type=style&index=1&id=37598b80&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37598b80"]])

export default __exports__